export default "__VITE_ASSET__DFIdmOcf__"